module.exports = __webpack_public_path__ + "img/5.9285fb7f.jpg";